import React from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import { SectionModel } from "../../../models/components.model";
import DocumentInfoComponent from "../../../components/detailInfo/documentInfoComponent";
import { DocumentUrl, Income } from "../../../models/loan.model";
import DetailInfoComponentThumbnail from "../../../components/thumbnail/detailInfoComponentThumbnail";

interface SchemaInfoModel {
  data?: Income[];
  documentList: DocumentUrl[];
  withoutDoc: string;
}
function _IncomeInfo({ data, documentList, withoutDoc, title }: any) {
  let sections: SectionModel[];
  if (data.incomeTypeTitle == "شغل") {
    sections = [
      // { dataKey: "incomeTypeTitle", rowCol: 4, title: "عنوان درآمد" },
      { dataKey: "jobTitle", rowCol: 4, title: "عنوان شغل" },
      { dataKey: "organizationTitle", rowCol: 4, title: "نام سازمان" },
      { dataKey: "phoneNumber", rowCol: 4, title: "شماره تلفن محل کار" },
      {
        dataKey: "amount",
        rowCol: 4,
        title: "مبلغ درآمد",
        dataPostValue: "ریال",
        hasThousandSeparatorFormat: true,
      },
      { dataKey: "address", rowCol: 4, title: "آدرس محل کار" },
    ];
  } else {
    sections = [
      // { dataKey: "incomeTypeTitle", rowCol: 4, title: "عنوان درآمد" },
      { dataKey: "jobTitle", rowCol: 4, title: "عنوان" },
      // { dataKey: "organizationTitle", rowCol: 4, title: "نام سازمان" },
      // { dataKey: "phoneNumber", rowCol: 4, title: "شماره تلفن محل کار" },
      {
        dataKey: "amount",
        rowCol: 4,
        title: "مبلغ درآمد",
        dataPostValue: "ریال",
        hasThousandSeparatorFormat: true,
      },
      { dataKey: "address", rowCol: 4, title: "آدرس" },
    ];
  }

  return (
    <DetailInfoComponentThumbnail
      sections={sections}
      data={data}
      documentList={documentList}
      title={false}
      height={"20vh"}
      showFooter={false}
      showDoc={withoutDoc}
      // headerHeight={"6vh"}
      // align={"center"}
    />
  );
}

export default function IncomeInfo(props: any) {
  return (
    <>
      {props.data?.map((item: any) => (
        <DivisionCmp
          child={
            <_IncomeInfo
              data={item}
              documentList={item.filesUrls}
              withoutDoc={props.withoutDoc}
            />
          }
          title={" در آمد از محل " + item.incomeTypeTitle}
        ></DivisionCmp>
      ))}
    </>
  );
}
